import {Injectable} from '@angular/core';
import {ApiClientService} from "../api-client/api-client.service";
import {Observable} from "rxjs";
import {Country} from "../../models/country";

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  loaded = false;
  countries: Country[] = [];

  constructor(
    private apiClient: ApiClientService
  ) {
  }

  private fetchAll(): Observable<any> {
    return new Observable<any>(subscriber => {
      this.apiClient.get('/country', {sort: 'name'}).subscribe((response) => {
        this.countries = response.getData().map((country: any) => new Country().deserialize(country));
        this.loaded = true;
        subscriber.next(this.countries);
        subscriber.complete();
      });
    });
  }

  private getByCode(countryCode: string): Country | null {
    return this.countries.find(e => e.isoCode === countryCode) ?? null;
  }

  findOneByCode(countryCode: string): Observable<Country | null> {
    return new Observable<Country | null>((subscriber) => {
      if (!this.loaded) {
        this.fetchAll().subscribe(() => {
          subscriber.next(this.getByCode(countryCode));
          return;
        });
      }

      subscriber.next(this.getByCode(countryCode));
      subscriber.complete();
    });
  }

  findAll(): Observable<Country[]> {
    return new Observable<Country[]>((subscriber) => {
      if (!this.loaded) {
        this.fetchAll().subscribe(() => {
          subscriber.next(this.countries);
          subscriber.complete();
        });
        return;
      }

      subscriber.next(this.countries);
      subscriber.complete();
    });
  }

  getName(code: string): string {
    const countryName = new Intl.DisplayNames(['en'], {type: 'region'});
    try {
      return countryName.of(code) ?? '';
    } catch (e) {
      return '';
    }
  }

  getFlag(code: string | null): string {
    return '/images/country/' + code?.toLowerCase() + '.svg';
  }
}
